
export default function routes($stateProvider) {
	$stateProvider
		.state('ssoLoginPage', {
			url: '/sso/login/:group?code&state',
			template: require('./ssoLogin.html'),
			resolve: {
				brands: ['Sso', '$stateParams', function (Sso, $stateParams) {
					if ($stateParams.group) {
						Sso.setGroup($stateParams.group);
						return Sso.getBrands($stateParams.group);
					} else {
						return [];
					}
				}],
			},
			controller: 'SsoLoginController',
			controllerAs: 'ssoLogin'
		});
}

routes.$inject = ['$stateProvider'];



// WEBPACK FOOTER //
// ./src/page/ssoLogin/ssoLogin.routes.js